import React from 'react';

export default function Tank23Icon({
  width = 64,
  height = 78,
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 92.254 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_TankBody">
	
		<radialGradient id={`${id}_1_`} cx="296.6345" cy="109.582" r="40.1146" gradientTransform="matrix(0.8528 0 0 1.7004 -206.8433 -92.6866)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.14" style={{stopColor: "#DCDCDC"}} />
		<stop offset="0.4" style={{stopColor: "#B7B7B7"}} />
		<stop offset="0.75" style={{stopColor: "#7B7B7B"}} />
		<stop offset="1" style={{stopColor: "#4C4C4C"}} />
	</radialGradient>
	<path fill={`url(#${id}_1_)`} d="M45.377,113.044c37.927,0,46.877-33.13,46.877-33.13s-8.912-5.664-46.127-5.664   C10.889,74.25,0,79.914,0,79.914S8.476,113.044,45.377,113.044z" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="-2.441406e-004" y1="43.9717" x2="92.4509" y2="43.9717">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M0.197,80.609V7.61L0,7.594C0,3.4,20.651,0,46.125,0C71.599,0,92.25,3.4,92.25,7.594l0.201,0.017   v72.999l-0.003-0.26c0,4.193-20.65,7.594-46.125,7.594c-25.474,0-46.125-3.4-46.125-7.594" />
	<ellipse fill="none" cx="46.127" cy="7.594" rx="46.125" ry="7.594" />
	<ellipse fill="#4C4C4C" cx="46.125" cy="7.594" rx="46.125" ry="7.594" />
</g>
<g id="Group_TankBlades">
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="29.6785" y1="77.7598" x2="29.6785" y2="61.7383">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M46.281,69.814l-25.193-8.076c-4.426,0-8.012,3.586-8.012,8.012c0,4.427,3.586,8.01,8.012,8.01   L46.281,69.814z" />
	
		<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="29.1814" y1="77.7598" x2="29.1814" y2="61.7383" gradientTransform="matrix(-1 0 0 1 91.2563 0)">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_4_)`} d="M45.472,69.814l25.193-8.076c4.426,0,8.012,3.586,8.012,8.012c0,4.427-3.586,8.01-8.012,8.01   L45.472,69.814z" />
</g>
<g id="Group_Hanger">
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="42.4138" y1="41.625" x2="49.196" y2="41.625">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<rect x="42.414" y="15.229" fill={`url(#${id}_5_)`} width="6.782" height="52.792" />
	<radialGradient id={`${id}_6_`} cx="45.6716" cy="70.2158" r="5.2529" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.14" style={{stopColor: "#DCDCDC"}} />
		<stop offset="0.4" style={{stopColor: "#B7B7B7"}} />
		<stop offset="0.75" style={{stopColor: "#7B7B7B"}} />
		<stop offset="1" style={{stopColor: "#4C4C4C"}} />
	</radialGradient>
	<circle fill={`url(#${id}_6_)`} cx="45.672" cy="70.216" r="5.253" />
</g>
    
      </g>
      <rect x="0" y="0" width="92.254" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
